import React__default from 'react';
import { dataViewSize, dataViewPage, pageMaxSizeSelector } from '@keepeek/commons';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import range from 'lodash/range';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { withSuspense } from '../../withSuspense/index.js';

var MINIMUM_PAGE_SIZE = 10;
var MAXIMUM_PAGE_SIZE = 200;
var SizeSelect = function (_a) {
    var id = _a.id, maxElementsPerPageAdminConf = _a.maxElementsPerPageAdminConf, dataViewKey = _a.dataViewKey;
    var _b = useRecoilState(dataViewSize(dataViewKey)), size = _b[0], setSize = _b[1];
    var setPage = useSetRecoilState(dataViewPage(dataViewKey));
    var pageMaxSizeTechPro = useRecoilValue(pageMaxSizeSelector);
    // take the lower configuration value :
    var pageMaxSize = Math.min(pageMaxSizeTechPro, maxElementsPerPageAdminConf || MAXIMUM_PAGE_SIZE);
    // apply minimum page size value if needed :
    pageMaxSize = Math.max(pageMaxSize, MINIMUM_PAGE_SIZE);
    // apply maximum page size value if needed :
    pageMaxSize = Math.min(pageMaxSize, MAXIMUM_PAGE_SIZE);
    var t = useTranslation("refront-components").t;
    var items = [MINIMUM_PAGE_SIZE];
    // Algo is :
    // 10, 20, 30..80, 90, 100, 200, 300, 400...
    // page size > 10 < 100 => step is 10
    if (pageMaxSize > MINIMUM_PAGE_SIZE) {
        items.push.apply(items, range(20, Math.min(pageMaxSize + 1, 101), 10));
        // page size > 100 => step is 100
        if (pageMaxSize > 100) {
            items.push.apply(items, range(200, pageMaxSize + 1, 100));
        }
    }
    var handleChangeSize = function (size) {
        // Scroll to top
        window.scrollTo({ top: 0, behavior: "smooth" });
        // Go to the first page
        setPage(1);
        // Change the size
        setSize(size);
    };
    return (React__default.createElement(FormControl, { size: "small" },
        React__default.createElement(InputLabel, { id: "".concat(id, "-size-label") }, t("components.pagination.sizeSelect.label")),
        React__default.createElement(Select, { variant: "outlined", defaultValue: size, onChange: function (e) { return handleChangeSize(Number(e.target.value)); }, labelId: "".concat(id, "-size-label"), id: "".concat(id, "-size-select"), label: t("components.pagination.sizeSelect.label"), sx: {
                width: function (theme) { return theme.spacing(13); }
            } }, items
            .sort(function (a, b) { return a - b; })
            .map(function (size) {
            return (React__default.createElement(MenuItem, { key: size, value: size }, size));
        }))));
};
var SizeSelect$1 = withSuspense(SizeSelect);

export { SizeSelect$1 as default };
//# sourceMappingURL=SizeSelect.js.map
